export function filtersMapper(floorPlan) {
  return {
    activeRoomType: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.activeRoomType) || [],
    availableRoomTypes: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.availableRoomTypes) || [],
    sections: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.sections) || [],
    sectionId: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.sectionId) || null,
    houseId: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.houseId) || null,
    houses: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.houses) || [],
    floorNumber: (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.floorNumber) || null
  };
}
export function mapFiltersToRequestParams(filters) {
  return {
    sectionId: filters.sectionId || undefined,
    houseId: filters.houseId || undefined,
    floorNumber: filters.floorNumber || undefined,
    roomType: filters.activeRoomType
  };
}